import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ScrollGallery } from './components/ScrollGallery';
import { BrandStory } from './components/BrandStory';
import { Services } from './components/Services';
import { MeetArtist } from './components/MeetArtist';
import { Portfolio } from './components/Portfolio';
import { CTASection } from './components/CTASection';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="relative min-h-screen overflow-hidden bg-brand-lilac selection:bg-brand-charcoal selection:text-brand-cream" data-id="element-0">
      {/* Ambient Background Light Blobs (Liquid Gel effect) */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-1">
        <div className="absolute top-[-10%] left-[-10%] w-[50vw] h-[50vw] bg-white/30 rounded-full blur-[120px] mix-blend-overlay" data-id="element-2" />
        <div className="absolute top-[40%] right-[-20%] w-[60vw] h-[60vw] bg-brand-cream/20 rounded-full blur-[150px] mix-blend-overlay" data-id="element-3" />
        <div className="absolute bottom-[-20%] left-[20%] w-[70vw] h-[70vw] bg-white/20 rounded-full blur-[130px] mix-blend-overlay" data-id="element-4" />
      </div>

      {/* Content Wrapper */}
      <div className="relative z-10" data-id="element-5">
        <Header data-id="element-6" />

        <main data-id="element-7">
          <Hero data-id="element-8" />
          <ScrollGallery data-id="element-9" />
          <BrandStory data-id="element-10" />
          <Services data-id="element-11" />
          <MeetArtist data-id="element-12" />
          <Portfolio data-id="element-13" />
          <CTASection data-id="element-14" />
          <Testimonials data-id="element-15" />
        </main>

        <Footer data-id="element-16" />
      </div>
      <FloatingWhatsApp data-id="element-17" />
    </div>;
}